import { getId as getReportId, getName
// @ts-expect-error migrate upstream files
} from 'dashboard-lib/public/report/report-schema';
import { getLayout, getReport
// @ts-expect-error migrate upstream files
} from 'dashboard-lib/public/widget/widget-schema';
// @ts-expect-error migrate upstream files
import { isStaticWidget } from 'dashboard-lib/public/report/report-logic';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const DashboardCardWrapper = ({
  children,
  widget
}) => {
  const report = getReport(widget);
  if (!isStaticWidget(report)) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "100%",
      backgroundColor: "fill-surface-default",
      as: "div",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    "data-widget-id": String(getReportId(report)),
    "data-test-id": "dashboard-widget",
    "data-layout": JSON.stringify(getLayout(widget).toJS()) //used for layoutUpdates test
    ,
    "data-report-id": String(getReportId(report)),
    tabIndex: 0,
    "aria-label": getName(report),
    flexDirection: "column",
    alignItems: "stretch",
    padding: "250",
    backgroundColor: "fill-surface-default",
    boxShadow: "300",
    borderWidth: "200",
    borderStyle: "solid",
    borderColor: "border-primary-on-fill",
    inlineSize: "100%",
    blockSize: "100%",
    overflow: "auto",
    children: children
  });
};
export default DashboardCardWrapper;